import { createContext, useContext } from 'react';
export const SideDrawerContext = createContext({
    collapsed: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleCollapsed: () => { }
});
export function useSideDrawerContext() {
    return useContext(SideDrawerContext);
}
